export function getContrastColor(hexColor) {
    // Remove '#' if present
    let hex = String(hexColor || '').replace(/^#/, '');
  
    // Handle 3-digit hex codes
    let r, g, b;
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else {
      // Invalid hex color format
      return '#3f4254'; // Default to black or throw an error
    }
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#3f4254' : 'white';
  }